export const setBlackoutTypes = (state, payload) => {
  state.blackoutTypes = payload
}
export const setCampsiteBlackouts = (state, payload) => {
  state.campsiteBlackouts = payload
}
export const setParkingBlackouts = (state, payload) => {
  state.parkingBlackouts = payload
}
